<!--
  Component: MetricSchoolOverview

  Safe Description, with additional logic for truncating long text for printing
  and showing alternate text for missing HST/YABC.
-->
<template>
  <div class="description safe school-overview">
    <div v-if="descLength>0" :class="isTruncated?'no-print':''">{{descDisplayText}}</div>
    <div v-else>
      <!-- Handle cases of empty text -->
      <template v-if="selectedSchoolType=='HST'">
        <p>Transfer Schools are small, academically rigorous, full-time high schools designed to re-engage students who have dropped out or who have fallen behind in credits. If you enroll in a Transfer High School, you will:</p>
        <ul>
          <li>Attend regular classes Monday through Friday</li>
          <li>Participate in workshops and get support with academic and personal goals</li>
          <li>Have access to tutoring, Regents prep, and extracurricular activities</li>
          <li>Develop college and career plans for life after high school</li>
        </ul>
      </template>
      <template v-else-if="selectedSchoolType=='YABC'">
        <p>The New York City YABC Program prides ourself on our mission of connecting with students, providing support through advocacy and counseling, paid internships, college and career advisement/preparation and, most importantly, motivating students to obtain their high school diploma. All students benefit from a hands on approach to learning in small classes, engaging in cooperative projects and reinforcing their problem solving skill sets. Regents prep, electives, and individualized tutoring are offered. We provide an environment where all students are supported and nurtured as they earn a high school diploma, which will expand students' options towards higher education and meaningful employment. We prepare students to compete in a global marketplace driven by technology.</p>
      </template>
      <template v-else>Not Available</template>
    </div>

    <!-- Alternate version for printing -->
    <div v-if="isTruncated" class="print-only">
      <span>{{descTruncatedText}}</span>
      <div class="footnote">For more on this school, please see the online version of this document.</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'

import { NS_CURRENT_REPORT } from '../const'
import DescriptionSafe from './DescriptionSafe'

const DESC_MAX_LENGTH = 700

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolType'
    ])
  }
})
export default class MetricSchoolOverview extends DescriptionSafe {
  /* Getters */

  get isTruncated () {
    return this.descLength > DESC_MAX_LENGTH
  }
  get descLength () {
    return this.descDisplayText.length
  }
  get descTruncatedText () {
    const t = this.descDisplayText
    const i = t.lastIndexOf(' ', DESC_MAX_LENGTH - 3) // replacing with three periods
    return t.slice(0, i) + '...'
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footnote {
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricSchoolOverview.vue